import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { editUser } from "../../redux/auth/actions";
import ProgressIndicator from "../../components/ProgressIndicator";

const CheckActiveUser = (props) => {
  const [saveLoader, setSaveLoader] = useState(false);

  const dispatch = useDispatch();
  // const saveLoader = useSelector((store) => store.auth.saveLoader);

  const onChangeUserAct = (state) => {
    const req = {
      username: props.row.username,
      first_name: props.row.first_name,
      last_name: props.row.last_name,
      email: props.row.email,
      password: props.row.password,
      groups: props.row.groups,
      is_active: state,
    };
    dispatch(
      editUser(req, props.row.id, props.index, null, null, setSaveLoader)
    );
  };

  return (
    <>
      <Form.Check
        disabled={saveLoader}
        defaultChecked={props.row.is_active}
        type="checkbox"
        onChange={(e) => onChangeUserAct(e.target.checked)}
      />
      <ProgressIndicator isLoading={saveLoader} />
    </>
  );
};

export default CheckActiveUser;
